/* eslint-disable security/detect-object-injection */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'
import { UserActions } from '../../redux/actions/user.action';
import { userService } from '../../service/user.service';
import CustomToast from '../AlertPopup';
import Footer from '../Footer';
import Header from '../Header';
import LoginScreen from './LoginScreen';
import OtpScreen from './OtpScreen';
import AppUnavailableScreen from './AppUnavailableScreen';

const DISTRIBUTOR_APP_DISABLED = 'DISTRIBUTOR_APP_DISABLED';

function Login({ login, VerifyOtp, resendOtp }) {
    const [appDisabled, setappDisabled] = useState(null);
    useEffect(() => {
        localStorage.removeItem('success-popup');
        document.body.style.overflow = 'hidden';
        userService.appStatus().then((val) => {
            // Fail open: only block when the API explicitly says the app is disabled
            setappDisabled(!val.error && val.data?.data?.distributor_app_access === false);
        });
    }, []);

    const [DistributorID, setDistributorId] = useState('');
    const [password, setpassword] = useState('');
    const [iniitialAuthentication, setiniitialAuthentication] = useState(false);
    const [isError, setisError] = useState(false);
    const [session, setsession] = useState('');
    const [loading, setloading] = useState(false);
    const [open, setopen] = useState(false);
    const [otp, setotp] = useState({
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
    });
    const [otpError, setotpError] = useState(false);
    /**
 *
 * @param {*} elmnt ;
 * For focusing on each input field.
 */
    const inputfocus = (elmnt) => {
        if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
            const next = elmnt.target.tabIndex - 2;
            if (next > -1) {
                elmnt.target.form.elements[next].focus();
            }
        } else {
            const regex = /^[0-9\b]+$/; // regular expression to check for numbers only
            if (regex.test(elmnt.target.value)) {
                if (elmnt.target.value.length === elmnt.target.maxLength) {
                    const next = elmnt.target.tabIndex;
                    if (next < 6) {
                        elmnt.target.form.elements[next].focus();
                    }
                }
            }
        }
    };

    /**
     * @param {e} e ;
     * validate whether all required fields are filled
     */
    const ValidateUserInput = (e) => {
        e.preventDefault();
        setloading(true);
        if (DistributorID !== '') {
            const type= DistributorID.match(/^[6-9]\d{9}$/) ? 'PHONE_NUMBER' : 'ACCOUNT_NUMBER'

            login(DistributorID).then((val) => {
                if (val.code === DISTRIBUTOR_APP_DISABLED) {
                    setappDisabled(true);
                } else if (!val.error && val.data.success_status) {
                    setsession(val.data.data.session);
                    setloading(false);
                    setopen(true);
                    localStorage.setItem('success-popup', 1);
                    setTimeout(() => {
                        setopen(false);
                    }, 4000);
                    setiniitialAuthentication(true);
                } else {
                    setisError(true);
                    setloading(false);
                }
            });
        } else {
            setisError(true);
            setloading(false);
        }
    };

    /**
     *
     * @param {*} DistributorID ;
     * resend otp handler
     */
    const resendOtphandler = () => {
        
        if (DistributorID) {
            const type= DistributorID.match(/^[6-9]\d{9}$/) ? 'PHONE_NUMBER' : 'ACCOUNT_NUMBER'

            resendOtp(DistributorID, session, type).then((val) => {
                if (val.code === DISTRIBUTOR_APP_DISABLED) {
                    setappDisabled(true);
                } else if (!val.error) {
                    setopen(true);
                    setTimeout(() => {
                        setopen(false);
                        // localStorage.setItem('user', JSON.stringify(val.data.data));
                    }, 4000);
                    setiniitialAuthentication(true);
                    setsession(val.data.data.session);
                } else {
                    setisError(true);
                }
            });
        } else {
            setisError(true);
        }
    };
    /**
 *
 * @returns all input fields are fill
 */
    const otpValidation = () => {
        let isvalid = true;
        Object.keys(otp).some((val) => {
            if (otp[val] === '') {
                isvalid = false;
            }
        });
        return isvalid;
    };
    /**
 * @param {} Event value ;*
 *It will construct OTP and return while submitting
 */

    const contructOtp = () => {
        let init = '';
        Object.keys(otp).map((val) => {
            init += otp[val];
        });
        return init;
    };

    /**
 * @param {e} Event value ;*
 *Otp validation returns true or false
 *Verify OTP Api call
 */
    const handleOtp = (e) => {
        e.preventDefault();
        setloading(true);
        const type= DistributorID.match(/^[6-9]\d{9}$/) ? 'PHONE_NUMBER' : 'ACCOUNT_NUMBER'
        if (otpValidation() === false) {
            setotpError(true);
            setloading(false);
        } else {
            setTimeout(() => {
                VerifyOtp(DistributorID, contructOtp(), session, type).then((val) => {
                    if (val.code === DISTRIBUTOR_APP_DISABLED) {
                        setappDisabled(true);
                        setloading(false);
                    } else if (!val.error) {
                        setloading(false);
                        localStorage.setItem('login_time', moment());
                    } else {
                        setotpError(true);
                        setloading(false);
                    }
                });
            }, 2000);
        }
    };
    function OtpSendMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-4 py-3" style={{ fontSize: '14px', color: '#808285' }}>
                OTP sent to your registered email address and mobile number.
            </p>
        );
    }

    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '14px', color: '#808285' }}>
                Otp Verification Successful!
                <br />
            </p>
        );
    }
    return (
        <div style={{ overflow: 'hidden' }}>
            <Header />
            {appDisabled && <AppUnavailableScreen />}
            {appDisabled === null && <div className="h-custom" />}
            {appDisabled === false && (!iniitialAuthentication ? (
                <LoginScreen
                    DistributorID={DistributorID}
                    password={password}
                    setDistributorId={setDistributorId}
                    setpassword={setpassword}
                    ValidateUserInput={ValidateUserInput}
                    isError={isError}
                    setisError={setisError}
                    loading={loading}
                />
            ) : (
                <OtpScreen
                    DistributorID={DistributorID}
                    otpError={otpError}
                    setotpError={setotpError}
                    setotp={setotp}
                    handleOtp={handleOtp}
                    inputfocus={inputfocus}
                    otp={otp}
                    resendOtp={resendOtphandler}
                    loading={loading}
                    setiniitialAuthentication={setiniitialAuthentication}

                />
            ))}
            {open && (
                <CustomToast
                    open={open}
                    setopen={setopen}
                    message={!iniitialAuthentication ? <OtpSuccessMeessage /> : <OtpSendMeessage />}
                />
            )}
            <Footer />
        </div>
    );
}
function mapState(state) {
    const { loggedIn } = state.authentication;
    const { alert } = state;
    return { loggedIn, alert };
}
const actionCreator = {
    // loginFunction: UserActions.login,
    login: UserActions.login,
    VerifyOtp: UserActions.VerifyOtp,
    resendOtp: UserActions.resendOtp,

};
const connectedLoginPage = connect(mapState, actionCreator)(Login);
export { connectedLoginPage as Login };
